export default "__VITE_ASSET__bc70796e__"